// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-21bb8308] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-navigation-search[data-v-21bb8308] {
  display: flex;
  gap: var(--app-navigation-padding);
  padding: var(--app-navigation-padding);
}
.app-navigation-search--has-actions .app-navigation-search__input[data-v-21bb8308] {
  flex-grow: 1;
  z-index: 3;
}
.app-navigation-search__actions[data-v-21bb8308] {
  display: flex;
  gap: var(--default-grid-baseline);
  margin-inline-start: 0;
  max-width: calc(2 * var(--default-clickable-area) + var(--default-grid-baseline));
  max-height: var(--default-clickable-area);
  transition: margin-inline-start var(--animation-quick);
}
.app-navigation-search__actions--hidden[data-v-21bb8308] {
  margin-inline-start: calc(-1 * var(--default-clickable-area));
}
.app-navigation-search__input[data-v-21bb8308] {
  --input-border-radius: var(--border-radius-element, var(--border-radius-pill)) !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppNavigationSearch-o97SOfOb.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,sBAAsB;EACtB,iFAAiF;EACjF,yCAAyC;EACzC,sDAAsD;AACxD;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,yFAAyF;AAC3F","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-21bb8308] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-navigation-search[data-v-21bb8308] {\n  display: flex;\n  gap: var(--app-navigation-padding);\n  padding: var(--app-navigation-padding);\n}\n.app-navigation-search--has-actions .app-navigation-search__input[data-v-21bb8308] {\n  flex-grow: 1;\n  z-index: 3;\n}\n.app-navigation-search__actions[data-v-21bb8308] {\n  display: flex;\n  gap: var(--default-grid-baseline);\n  margin-inline-start: 0;\n  max-width: calc(2 * var(--default-clickable-area) + var(--default-grid-baseline));\n  max-height: var(--default-clickable-area);\n  transition: margin-inline-start var(--animation-quick);\n}\n.app-navigation-search__actions--hidden[data-v-21bb8308] {\n  margin-inline-start: calc(-1 * var(--default-clickable-area));\n}\n.app-navigation-search__input[data-v-21bb8308] {\n  --input-border-radius: var(--border-radius-element, var(--border-radius-pill)) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
